import { render, staticRenderFns } from "./ModalWebCam.vue?vue&type=template&id=a1ab0a3e&"
import script from "./ModalWebCam.vue?vue&type=script&lang=js&"
export * from "./ModalWebCam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports